/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Media_Error_Too_LargeInputs */

const vi_media_error_too_large = /** @type {(inputs: Media_Error_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File quá lớn: tối đa ${i?.max} MB. Hãy nén hoặc giảm kích thước rồi tải lại.`)
};

/**

* @param {Media_Error_Too_LargeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_error_too_large = /** @type {((inputs: Media_Error_Too_LargeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Error_Too_LargeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_error_too_large(inputs)
});